module.exports = __webpack_public_path__ + "img/key-words.7b5070b1.png";